module.exports = __webpack_public_path__ + "img/bar.04437a8b.svg";